import fetch from 'fetch-retry'
import { observable, flow } from 'mobx'
const autUri = process.env.REACT_APP_AUTH_BASE_URI
class UserStore {
  @observable profile = null
  @observable loading = true
  getProfile = flow(function * () {
    const response = yield fetch(`${autUri}`, {
      credentials: 'include',
      method: 'GET'
    })

    if (response.ok) {
      const profile1 = yield response.json()
      // console.log(profile1)
      // const { user_name: [userId], param: [jsonParams], userRole: [userRole] } = data.claims
      // const profile = yield response.json()
      // const params = JSON.parse(jsonParams)
	  const profile2= yield profile1['token']
	  if (profile2){
	  profile2.userRole=profile2.roles[0]
	  }
	  const profile = yield profile2
      this.loading = false
      this.profile = profile
    } else {
      this.loading = false
    }
  })
}

const userStore = new UserStore()

export default userStore



// WEBPACK FOOTER //
// ./src/stores/user.js